<div class="d-flex justify-content-center mx-2 my-3">
    <button class="btn btn-outline-success me-auto mt-5" data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Fill Your Details</button>
    <!-- <button class="btn btn-primary" (click)="backward()"><i
        class="fa-solid fa-backward"></i></button>
    <span class="mt-1 mx-2"><p class="fs-5 writingstyle"> {{contractName}}</p></span>
    <button class="btn btn-primary" (click)="forward()"><i
        class="fa-solid fa-forward"></i></button> -->
</div>
  
  <div class="container-fluid" #pdfViewerContainer >
    <ngx-extended-pdf-viewer
     #pdfViewer
      [src]="pdfSrc"
      [showTextEditor]="true"
      [showOpenFileButton]="false"
      [(sidebarVisible)]="sidebarVisible"
      >
    </ngx-extended-pdf-viewer>
  </div>

  

  <div class="offcanvas  offcanvas-end" tabindex="-1" id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel"></h5>
      <button type="button" class="btn-close text-reset"
        data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <form [formGroup]="contractForm"  >
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Full Name</label>
          <input type="text" class="form-control" formControlName="candidateName">    
        </div>


        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Company Name And ACN</label>
          <input type="text" class="form-control" formControlName="companyNameAndACN">    
        </div>


        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Commencement Date</label>
          <input type="date" class="form-control" formControlName="commencementDate">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">End Date</label>
          <input type="date" class="form-control" formControlName="endDate">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Service Order Date</label>
          <input type="date" class="form-control" formControlName="serviceOrderDate">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Services Performed</label>
          <input type="text" class="form-control" formControlName="servicesPerformed">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Trainer Assessor</label>
          <input type="text" class="form-control" formControlName="trainerAssessor">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Address</label>
          <input type="text" class="form-control" formControlName="address">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Amount</label>
          <input type="text" class="form-control" formControlName="amount">    
        </div>

        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Phone Number</label>
          <input type="text" class="form-control" formControlName="phoneNumber"> 
        </div>

        <!-- <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Position</label>
          <input type="text" class="form-control" formControlName="position">    
        </div> -->

        <!-- <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Date</label>
          <input type="date" class="form-control" id="date" placeholder="Date" formControlName="date">
       </div> -->
      
      <div class="block border border-4 my-auto">
        <canvas
        #canvas
        (touchstart)="startDrawing($event)"
        (touchmove)="moved($event)"
        width="300"
        height="300"></canvas>
      </div>
      <div class="mt-5">
      <button class="btn btn-outline-danger my-2 me-2" (click)="clearPad($event)">Clear</button>
      <button class="btn btn-outline-success" (click)="submit()">
        <small class="loadingspinner d-inline-block ms-2" *ngIf="loader"></small>
        Submit Contract</button>
    </div>
      <!-- <button class="btn btn-success" (click)="saveSignature()">Save Signature</button> -->
      <!-- <button type="submit" class="btn btn-outline-primary my-2"   [disabled]="!mySignatureForm.valid"><span>Submit the signature</span>
        <small class="loadingspinner d-inline-block ms-2" *ngIf="submitDetials"></small></button> -->
    </form>
    <!-- <div *ngFor="let imageData of imageFormArray.controls; let i = index">
      <img [src]="imageData.value" alt="Image {{ i + 1 }}">
    </div> -->
    </div>
  </div>